import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/axios';
import VCalendar from 'v-calendar';
import VueIframe from 'vue-iframes';
import '../../olsStateManagement/css/olsOverride.sass';

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App),
}).$mount('.abstract')


Vue.use(VCalendar, { componentPrefix: 'vc' });
Vue.use(VueIframe);
